/* eslint-disable @typescript-eslint/no-empty-function */
import {
  HeaderContextValue,
  HeaderProps,
} from '@/sinister/header/entities/header'
import { useHelperItems } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import React, { FC, useEffect, useState } from 'react'

const HeaderContext = React.createContext<HeaderContextValue>(
  {} as HeaderContextValue
)

export const HeaderProvider: FC<HeaderProps> = ({
  children,
  enabledSearchAutocomplete = true,
  enabledOpModelSuffix = false,
  layout = {
    desktop: 'A',
    mobile: 'A',
    simple: 'A',
    components: {
      moreAbout: {
        mobile: 'A',
      },
    },
  },
  maxItemsInline = 6,
  store,
  isSimple = false,
  isLightBackground = false,
  showChooseOpModelMessage = false,
  copies,
  LinkComponent = null,
  languagesConfig = { enabled: false },
  initialSearchValue = '',
  clientId = null,
  customer = {},
  opsmodel = {},
  address = {},
  site = '',
  help,
  helpV3,
  placeholder,
  showAddressLabel = false,
  enabledQuotes = false,
  pathname,
  isMobile = false,
  initialCategories = [],
  logo,
  slug,
  domain,
  onClickOpModel = () => {},
  onClickLogo = () => {},
  onClickAccountOption = () => {},
  onPromotionsOnClick = () => {},
  onCategoryOnClick = () => {},
  onClickFavorites = () => {},
  onClickCart = () => {},
  onClickSearch = () => {},
  onClickSuggested = () => {},
}) => {
  const { parsedHelpers } = useHelperItems({
    position: 'header',
    help,
    helpV3,
  })
  const [colorHeader, setColorHeader] = useState<string>()
  const [colorSubheader, setColorSubheader] = useState<string>()

  const langConfig = {
    size: 20,
    trigger: ['click'],
    ...languagesConfig,
  }

  useEffect(() => {
    if (isMobile) {
      setColorHeader('--app-header-color-mobile-v3')
      setColorSubheader('--app-subheader-color-mobile-v3')
    } else {
      setColorHeader('--app-header-color-desktop-v3')
      setColorSubheader('--app-subheader-color-desktop-v3')
    }
  }, [isMobile])

  const value = {
    initialCategories,
    parsedHelpers,
    layout,
    maxItemsInline,
    store,
    customer,
    colorHeader,
    colorSubheader,
    isSimple,
    copies,
    isLightBackground,
    LinkComponent,
    langConfig,
    onClickOpModel,
    onClickLogo,
    onClickAccountOption,
    onCategoryOnClick,
    onPromotionsOnClick,
    onClickFavorites,
    onClickCart,
    initialSearchValue,
    clientId,
    onClickSearch,
    onClickSuggested,
    showChooseOpModelMessage,
    opsmodel,
    address,
    site,
    help,
    helpV3,
    placeholder,
    showAddressLabel,
    enabledQuotes,
    pathname,
    enabledSearchAutocomplete,
    enabledOpModelSuffix,
    isMobile,
    logo,
    slug,
    domain,
  }

  return (
    <HeaderContext.Provider value={value as HeaderContextValue}>
      {children}
    </HeaderContext.Provider>
  )
}

export const useHeaderContext = () => {
  const context = React.useContext(HeaderContext)
  if (!context) {
    throw new Error('HeaderContext: no context')
  }
  return context
}
